<template>
  <div class="carousel">
    <div class="carousel-container">
      <!-- 轮播图片 -->
      <div 
        class="carousel-items"
        :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
      >
        <div 
          v-for="(item, index) in carouselData" 
          :key="index"
          class="carousel-item"
        >
          <img :src="item.url" :alt="`轮播图${index + 1}`">
        </div>
      </div>
      
      <!-- 底部指示器 -->
      <div class="carousel-indicators">
        <div 
          v-for="(item, index) in carouselData" 
          :key="index"
          class="indicator-line"
          :class="{ active: currentIndex === index }"
          @click="setCurrentIndex(index)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeCarousel',
  props: {
    carouselData: {
      type: Array,
      default: () => []
    },
    interval: {
      type: Number,
      default: 5000
    }
  },
  data() {
    return {
      currentIndex: 0,
      timer: null,
      isInitialized: false
    }
  },
  watch: {
    carouselData: {
      immediate: true,
      handler(newVal) {
        if (newVal.length && !this.isInitialized) {
          this.$nextTick(() => {
            this.initCarousel()
            this.isInitialized = true
          })
        }
      }
    }
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    initCarousel() {
      this.stopAutoPlay()
      this.startAutoPlay()
    },
    setCurrentIndex(index) {
      if (index !== this.currentIndex) {
        this.currentIndex = index
        this.resetAutoPlay()
      }
    },
    startAutoPlay() {
      if (this.interval > 0 && this.carouselData.length > 1) {
        this.timer = setInterval(() => {
          this.currentIndex = (this.currentIndex + 1) % this.carouselData.length
        }, this.interval)
      }
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    resetAutoPlay() {
      this.stopAutoPlay()
      this.startAutoPlay()
    }
  }
}
</script>

<style scoped>
.carousel {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.carousel-container {
  width: 100%;
  position: relative;
  height: auto;
}

.carousel-items {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 100%;
}

.carousel-item {
  flex: 0 0 100%;
  width: 100%;
  height: auto;
}

.carousel-item img {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
}

.carousel-indicators {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.indicator-line {
  width: 30px;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator-line.active {
  background-color: #FFFFFF;
}
</style> 